import { softDarkTheme, softLightTheme } from "@Src/themes/softTheme";
import {
	defaultDarkTheme,
	defaultLightTheme,
	houseDarkTheme,
	houseLightTheme,
	nanoDarkTheme,
	nanoLightTheme,
	type RaThemeOptions,
	radiantDarkTheme,
	radiantLightTheme,
} from "react-admin";

export type ThemeName = "soft" | "default" | "nano" | "radiant" | "house";

export interface Theme {
	name: ThemeName;
	light: RaThemeOptions;
	dark: RaThemeOptions;
}

export const themes: Theme[] = [
	{ name: "soft", light: softLightTheme, dark: softDarkTheme },
	{ name: "default", light: defaultLightTheme, dark: defaultDarkTheme },
	{ name: "nano", light: nanoLightTheme, dark: nanoDarkTheme },
	{ name: "radiant", light: radiantLightTheme, dark: radiantDarkTheme },
	{ name: "house", light: houseLightTheme, dark: houseDarkTheme },
];
